// libs
import { Box, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import Markdown from 'markdown-to-jsx';
import Image from 'next/image';
// src
import CalculateBorrow from '@layouts/CalculateBorrow';
// styles
import styles from './styles';

interface BorrowCalculatorSectionProps {
  borrowCalculator: {
    richTextTitleBorrow?: string;
    title?: string;
    subtitle?: string;
    img: string;
    calculateButton: string;
    fieldOneLabel: string;
    fieldTwoLabel: string;
  };
  borrowResult: {
    richTextTitleResult?: string;
    title?: string;
    subtitle?: string;
    img: string;
    resultText1: string;
    resultText2: string;
    recalculateButton: string;
    buttonLink: {
      label: string;
      href: string;
    };
  };
}

const overrides = {
  h1: {
    component: Typography,
    props: {
      variant: 'h1',
      sx: styles.heading
    }
  },
  p: {
    component: Typography,
    props: {
      variant: 'body1',
      sx: styles.headingText
    }
  }
};

export default function BorrowCalculatorSection({
  borrowCalculator,
  borrowResult
}: BorrowCalculatorSectionProps) {
  const [hasResult, setHasResult] = useState(false);

  return (
    <Box sx={styles.root} component="section">
      <Grid
        container
        justifyContent="space-between"
        sx={{ minHeight: '48rem', position: 'relative' }}
      >
        <Grid item xs={12} lg={6} sx={styles.gridItemLeft}>
          <Markdown options={{ overrides }}>
            {hasResult
              ? borrowResult?.richTextTitleResult || ''
              : borrowCalculator?.richTextTitleBorrow || ''}
          </Markdown>
          <Box sx={styles.calculatorWrapper}>
            <CalculateBorrow
              calculateButtonLabel={borrowCalculator.calculateButton}
              reCalculateButtonLabel={borrowResult.recalculateButton}
              buttonLink={borrowResult.buttonLink}
              fieldOneLabel={borrowCalculator.fieldOneLabel}
              fieldTwoLabel={borrowCalculator.fieldTwoLabel}
              resultText1={borrowResult.resultText1}
              resultText2={borrowResult.resultText2}
              setHasResult={setHasResult}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sx={styles.imageContainer}>
          <Image
            src={hasResult ? borrowResult.img : borrowCalculator.img}
            sizes="100vw"
            alt="calulating-mortagage-image"
            width={0}
            height={0}
            priority
          />
        </Grid>
      </Grid>
    </Box>
  );
}
